import React from 'react';
import { connect } from 'react-redux';
import { cloneDeep } from 'lodash';
import { instanceOf } from 'prop-types';

import {
  pullCampaignOffices,
  updateOrCreateOffice,
  pullUsers,
  pullGroups,
  pullUserGroups,
  createUserGroup,
  deleteUserGroup,
  updateOrCreateUser,
  pullCampaigns,
  updateOrCreateCampaign,
  pullCampaignWebhooks,
  updateOrCreateWebhook,
} from '../../store/api/calls';

import { makeInactiveUserActive, updateUser } from '../../store/actions';

import { isMinLength, isEmail } from '../../utils/forms/validators';

import { get as _get } from 'lodash';

import { updateCampaignAggregates, getFocusedCampaign } from '../../store/api/calls';
import { navigateAway } from '../../utils/nav';

import NavBaseTemplate from '../templates/NavBaseTemplate';
import BaseForm from '../theme/forms/BaseForm';
import DataTable from '../theme/tables/DataTable';
import BaseModal from '../theme/modals/BaseModal';
import FeedbackTile from '../theme/modals/FeedbackTile';
import Tabs from '../theme/menus/Tabs';
import Moment from 'moment';
import api from '../../store/api/api';
import Input from '../theme/forms/Input';
import { filterText } from '../../utils/filterText';

// t

class AdminScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editModalOpen: false,
      editModalErrorMsg: null,
      deleteModalOpen: false,
      reactivateModalOpen: false,
      removeMFAModalOpen: false,

      editingInstance: {},
      showCampaignEditSection: true,
      section: 'users', //'offices',
      deactivatedUserView: false,
      formInputs: [],
      geocodeError: false,
      geoErrorMessage: '',
      errMsg: 'Something went wrong.',
      userPermissionsGroups: [],
      filterText: '',
      showFilter: false,
      loading: false,
      error: false,
    };

    this.permissionsLabel = '';
    this.permissionsInputs = [];
    this.adminInputs = [];
  }

  componentDidMount() {
    Promise.allSettled([
      pullCampaignOffices(),
      pullUsers(),
      pullCampaigns(),
      pullCampaignWebhooks(),
      pullGroups(),
    ]);
  }

  _setError(errMsg) {
    this.setState({ error: true, errMsg }, () =>
      setTimeout(() => this.setState({ error: false, errMsg: 'Something went wrong.' }))
    );
  }

  _filterKeysForOfficeDataTable() {
    return this.props.offices.map((d) => ({
      name: d.name,
      address: d.addressline1 + ' ' + d.addressline2,
      city: d.city,
      state: d.statecode,
      zip: d.zip5,
      created_on: new Moment(d.created_at).format('MM/DD/YY'),
      _created_on: new Moment(d.created_at),
      _data: d,
    }));
  }

  _filterKeysForUserDataTable(deactivated = false) {
    const users = deactivated ? this.props.deactivated_users : this.props.users;

    return users.map((d) => {
      if (!d.profile) d.profile = {};
      return {
        username: d.username,
        first_name: d.first_name,
        last_name: d.last_name,
        mfa:
          d.profile.mfa_enabled || d.profile.mfa_required ? (
            this._getChangeMFAButton(d)
          ) : (
            <span>No</span>
          ),
        _mfa: d.profile.mfa_enabled ? 2 : d.profile.mfa_required ? 1 : 0,
        date_joined: new Moment(d.date_joined).format('MM/DD/YY'),
        _date_joined: new Moment(d.date_joined),
        _data: d,
      };
    });
  }

  _filterKeysForCampaignDataTable() {
    return this.props.campaigns.map((d) => ({
      name: d.name,
      description: d.description,
      _data: d,
    }));
  }

  _filterKeysForWebhookDataTable = () => {
    return this.props.webhooks.map((d) => ({
      name: d.name,
      endpoint: d.endpoint,
      created_on: new Moment(d.created_at).format('MM/DD/YY'),
      _created_on: new Moment(d.created_at),
      _data: { ...d, headers: JSON.stringify(d.headers) },
    }));
  };

  _handlePermissionsGroupChange(e) {
    let value = JSON.parse(e.target.value);

    if (e.target.checked) {
      createUserGroup({ user: value.user, group: value.group }).then((d) => {
        // need to then check the base group if it's not already checked.
        if (d.name.indexOf('manager') > -1) {
          // need to check for that matching group.
          let name = d.name.match(/^(\S+)_manager/);
          let timestamp = d.name.match(/__(\d+-\d+)/);

          let baseGroup = value.modelInstance.userGroups.find(
            (g) => g.name === name[1] + '__' + timestamp[1]
          );

          // if the user has been added an manager and they don't also belong to that campaign
          // add them.
          if (!baseGroup) {
            let group = this.props.permissions_groups.find(
              (p) => p.name === name[1] + '__' + timestamp[1]
            );
            createUserGroup({ user: value.user, group: group.id }).then(
              this._generatePermissionsInputs(value.modelInstance)
            );
          }
        }
      });
    } else {
      deleteUserGroup(value);
    }
  }

  _ensureCanAddGroup() {
    let groups = cloneDeep(this.props.permissions_groups);

    let admin = groups.find((item) => item.name === 'admin');
    let root = groups.find((item) => item.name === 'root');

    if (admin || root) return this.props.permissions_groups;

    let managing = groups.filter((item) => item.name.includes('manager'));
    let allowed = [];

    groups.forEach((group) => {
      let name = group.name.split('__')[0];
      var regex = new RegExp(name, 'g');
      let manager = managing.find((item) => item.name.match(regex));
      if (manager) {
        allowed.push(group);
      }
    });

    return allowed;
  }

  _generatePermissionsInputs(modelInstance) {
    // make sure to clear inputs each time.
    this.adminInputs = [];
    this.permissionsInputs = [];
    this.permissionsLabel = `${modelInstance.first_name} ${modelInstance.last_name}`;
    // If someone is editing a more priveledged user, don't show the more priveledged status
    let allowed_groups = this._ensureCanAddGroup();
    console.log('allowed groups');
    allowed_groups.forEach((item, index) => {
      console.log(item);
      let value = false;
      // split out the timestamp and/or return original string if no timestamp
      let title = item.name.split('__')[0].replace(/_/g, ' ');
      let contained_group = modelInstance.userGroups.find((u_group) => u_group.id === item.id);
      if (contained_group) {
        value = true;
      }

      if (title.indexOf('admin') > -1 || title.indexOf('root') > -1 || title === 'api user') {
        this.adminInputs.push(
          <Input
            classNames=""
            key={item.name}
            type="switch-left"
            title={title}
            onChange={this._handlePermissionsGroupChange.bind(this)}
            defaultValue={value}
            classNames={['permissions-modal']}
            value={JSON.stringify({ group: item.id, user: modelInstance.id, modelInstance })}
          />
        );
      } else {
        this.permissionsInputs.push(
          <Input
            key={item.name}
            type="switch-left"
            title={title}
            onChange={this._handlePermissionsGroupChange.bind(this)}
            defaultValue={value}
            classNames={['permissions-modal']}
            value={JSON.stringify({ group: item.id, user: modelInstance.id, modelInstance })}
          />
        );
      }
    });
  }

  _generateFormInputs(creating = false) {
    if (this.state.section === 'offices') {
      this.formInputs = [
        {
          type: 'text',
          title: 'Office Name',
          dataKey: 'name',
          placeholder: 'Pleasantville',
        },
        {
          type: 'text',
          title: 'Address Line 1',
          dataKey: 'addressline1',
          placeholder: '123 Main',
        },
        {
          type: 'text',
          title: 'Address Line 2',
          dataKey: 'addressline2',
          placeholder: 'Suite 100',
        },
        {
          type: 'text',
          title: 'City',
          dataKey: 'city',
          placeholder: 'Pleasantville',
        },
        {
          type: 'text',
          title: 'State',
          dataKey: 'statecode',
          placeholder: 'Two Character State Code',
        },
        {
          type: 'Zip',
          title: 'ZipCode',
          dataKey: 'zip5',
          placeholder: creating
            ? 'At least five characters, with at least one number and letter'
            : "Leave blank if you don't want to change this.",
        },
      ];
    }

    if (this.state.section === 'users') {
      this.formInputs = [
        {
          type: 'text',
          title: 'First Name',
          dataKey: 'first_name',
          placeholder: 'Jane',
          validator: isMinLength(1),
          errorMsg: 'This field is required',
        },
        {
          type: 'text',
          title: 'Last Name',
          dataKey: 'last_name',
          placeholder: 'Smith',
          validator: isMinLength(1),
          errorMsg: 'This field is required',
        },
        {
          type: 'text',
          title: 'Username',
          dataKey: 'username',
          placeholder: 'Make you sure you have a system for this...',
          validator: isMinLength(1),
          errorMsg: 'This field is required',
        },
        {
          type: 'text',
          title: 'Email',
          dataKey: 'email',
          placeholder: 'Make you sure you have a system for this...',
          validator: isEmail,
          errorMsg: 'This must be a valid email',
        },
        {
          type: 'text',
          title: 'Password',
          dataKey: 'password',
          placeholder: creating
            ? 'At least five characters, with at least one number and letter'
            : "Leave blank if you don't want to change this.",
          validator: creating ? isMinLength(1) : () => true,
          errorMsg: 'This field is required',
        },
      ];
    }

    if (this.state.section === 'campaigns') {
      this.formInputs = [
        {
          type: 'text',
          title: 'Name',
          dataKey: 'name',
          placeholder: 'Client',
        },
        {
          type: 'text',
          title: 'Descriptiion',
          dataKey: 'description',
          placeholder: 'Where is it and what are we doing there?',
        },
      ];
    }

    if (this.state.section === 'webhooks') {
      this.formInputs = [
        {
          type: 'text',
          title: 'Name',
          dataKey: 'name',
          placeholder: 'Name this something identifiable',
        },
        {
          type: 'text',
          title: 'Endpoint',
          dataKey: 'endpoint',
          placeholder: 'dumpdatahere.io/listener',
        },
        {
          type: 'text',
          title: 'Headers',
          dataKey: 'headers',
          placeholder: 'must be valid JSON',
        },
      ];
    }
  }

  onOpenEditModal = (modelInstance = {}, creating = false) => {
    this.setState({ formInputs: this._generateFormInputs(creating) });
    this.buildInputsWithPrepopulatedFields(modelInstance);
    this.setState({ editModalOpen: true, editingInstance: modelInstance });
  };

  onCloseEditModal = () => {
    this.setState({ editModalOpen: false, editingInstance: {}, editModalErrorMsg: null });
  };

  onOpenReactivateModal = (modelInstance = {}) => {
    this.setState({ reactivateModalOpen: true, editingInstance: modelInstance });
  };

  onCloseReactivateModal = () => {
    this.setState({ reactivateModalOpen: false, editingInstance: {} });
  };

  handleReactivateSubmission = () => {
    updateOrCreateUser({ id: this.state.editingInstance.id, is_active: true })
      .then((d) => {
        this.onCloseReactivateModal();
        this.onOpenPermissionsModal(d);
        this.props.makeInactiveUserActive(d); // put the user into active user list
      })
      .catch((err) => {});
  };

  onOpenPermissionsModal = (modelInstance = {}, creating = false) => {
    this.setState({ loading: true });
    pullUserGroups({ user: modelInstance.id }).then((userGroups) => {
      modelInstance.userGroups = userGroups || [];
      this._generatePermissionsInputs(modelInstance);
      this.setState({ permissionsModalOpen: true, editingInstance: modelInstance, loading: false });
    });
  };

  onClosePermissionsModal = (modelInstance = {}) => {
    this.setState({ permissionsModalOpen: false, editingInstance: modelInstance });
  };

  onOpenDeleteModal = (modelInstance = {}) => {
    this.setState({ deleteModalOpen: true, editingInstance: modelInstance });
  };

  onCloseDeleteModal = () => {
    this.setState({ deleteModalOpen: false, editingInstance: {}, creating: false });
  };

  _generateDeleteModalText = () => {
    if (this.state.section === 'offices') {
      return 'Are you sure you want to remove the office ' + this.state.editingInstance.name + '?';
    } else if (this.state.section === 'users') {
      return (
        'Are you sure you want to remove user ' +
        this.state.editingInstance.first_name +
        ' ' +
        this.state.editingInstance.last_name +
        '?'
      );
    } else if (this.state.section === 'campaigns') {
      return (
        'Are you sure you want to remove the campaign ' + this.state.editingInstance.name + '?'
      );
    }
  };

  _getChangeMFAButton = (user) => {
    let activated = user.profile.mfa_enabled;
    return (
      <a
        href={'#'}
        className={activated ? 'primary-text' : 'danger-text'}
        onClick={() => this.onOpenMFAModal(user)}
      >
        {activated ? 'YES' : 'REQUIRED'}
      </a>
    );
  };

  onOpenMFAModal = (user) => {
    this.setState({ removeMFAModalOpen: true, editingInstance: user });
  };

  onCloseMFAModal = () => {
    this.setState({ removeMFAModalOpen: false, editingInstance: {} });
  };

  removeMFAFromUser = () => {
    let user = this.state.editingInstance || {};
    let profile = user.profile;
    if (!profile) return;

    return api
      .patch(`/profiles/${profile.id}/`, { mfa_enabled: 0, mfa_required: 0 })
      .then((res) => {
        this.props.updateUser({ ...user, profile: { ...profile, ...res.data } });
      })
      .catch(() => {
        this._setError(`Error: Unable to disable MFA for ${user.first_name} ${user.last_name}`);
      })
      .then(this.onCloseMFAModal);
  };

  buildInputsWithPrepopulatedFields = (modelInstance) => {
    this.formInputs.forEach((d) => {
      d.value = modelInstance[d.dataKey];
    });
  };

  geocode = (data) => {
    let address_obj = { ...data };
    // only send address info.
    delete address_obj.campaign;
    delete address_obj.name;
    let address = Object.values(address_obj).join(' ');

    return api
      .get('/geocode', { address })
      .then((res) => {
        if (res.data.results.length > 0) {
          return res.data.results;
        } else {
          return Promise.reject(new Error('No Matches Found'));
        }
      })
      .catch((err) => {
        return Promise.reject(
          new Error('Unable To Create Office. Please check address for errors and try again.')
        );
      });
  };

  handleUpdateCreateSubmission = (data) => {
    const id = this.state.editingInstance.id;

    if (id) data = { ...data, id };

    if (this.state.section === 'offices') {
      data = { ...data, campaign: this.props.focusedCampaign.id };
      this.geocode(data)
        .then((res) => {
          data.lat = res[0].geometry.location.lat;
          data.lon = res[0].geometry.location.lng;
          updateOrCreateOffice(data).then(() => {
            this.onCloseEditModal();
          });
        })
        .catch((err) => {
          this.onCloseEditModal();
          this.setState({ geocodeError: true, geoErrorMessage: err.message });
          setTimeout(() => this.setState({ geocodeError: false }), 10000);
        });
    } else if (this.state.section === 'users') {
      updateOrCreateUser(data)
        .then((d) => {
          this.onCloseEditModal();
          this.onOpenPermissionsModal(d);
        })
        .catch((err) => {
          const response_data = _get(err, 'response.data', {});
          if (response_data.username) {
            this.setState({
              editModalErrorMsg:
                'That username already exists. Please use a different username or reactivate.',
            });
          } else {
            this.onCloseEditModal();
          }
        });
    } else if (this.state.section === 'campaigns') {
      updateOrCreateCampaign(data)
        .then(this.onCloseEditModal())
        .then(() => pullGroups());
    } else if (this.state.section === 'webhooks') {
      let headers;
      if (data.headers) {
        try {
          headers = JSON.parse(data.headers);
        } catch {
          this.setState({ editModalErrorMsg: 'Your headers are invalid JSON.' });
          return;
        }
      }
      updateOrCreateWebhook({ ...data, headers, campaign: this.props.focusedCampaign.id }).then(
        this.onCloseEditModal()
      );
    }
  };

  handleRemoveSubmission = () => {
    const id = this.state.editingInstance.id;
    const data = { is_active: false, id };

    if (this.state.section === 'offices') {
      updateOrCreateOffice(data).then(this.onCloseDeleteModal);
    } else if (this.state.section === 'users') {
      updateOrCreateUser(data).then(this.onCloseDeleteModal);
    } else if (this.state.section === 'campaigns') {
      updateOrCreateCampaign(data).then(this.onCloseDeleteModal);
    }
  };

  handleEditFocusedCampaign = () => {
    this.setState({
      section: 'campaigns',
    });
    setTimeout(() => this.onOpenEditModal(this.props.focusedCampaign), 300);
  };

  handleRemoveFocusedCampaign = () => {
    this.setState({
      section: 'campaigns',
    });

    setTimeout(() => this.onOpenDeleteModal(this.props.focusedCampaign), 300);
  };

  toggleFilter() {
    if (this.state.showFilter) {
      this.setState({ showFilter: !this.state.showFilter, filterText: '' });
    } else {
      this.setState({ showFilter: !this.state.showFilter });
    }
  }

  getDeactivatedUserView = () => {
    console.log('firing deactivate view');
    this.setState({ deactivatedUserView: true });
    pullUsers({ deactivated: 1 });
  };

  _isError = () => {
    const { props } = this;
    return (
      props.users_error ||
      props.permissions_error ||
      props.campaigns_error ||
      props.offices_error ||
      this.state.error
    );
  };

  _isLoading = () => {
    const { props } = this;
    return (
      props.users_loading ||
      props.permissions_loading ||
      props.campaigns_loading ||
      props.offices_loading ||
      this.state.loading
    );
  };

  _showSuccess = () => {
    const timeout_length = 3000;
    this.setState(
      { showSuccess: true },
      setTimeout(() => this.setState({ showSuccess: false })),
      timeout_length
    );
  };

  render() {
    return (
      <NavBaseTemplate location={this.props.location} showAdmin={this.props.is_admin}>
        <Tabs
          tabs={[
            {
              display: 'Users',
              onClick: () => this.setState({ section: 'users' }),
              active: this.state.section === 'users',
            },
            {
              display: 'Offices',
              onClick: () => this.setState({ section: 'offices' }),
              active: this.state.section === 'offices',
            },
            {
              display: 'Campaigns',
              onClick: () => this.setState({ section: 'campaigns' }),
              active: this.state.section === 'campaigns',
            },
            {
              display: 'Webhooks',
              onClick: () => this.setState({ section: 'webhooks' }),
              active: this.state.section === 'webhooks',
            },
          ]}
        />
        {/*  START OFFICES DATA TABLE SECTION  */}
        {this.state.section === 'offices' && (
          <div>
            {this.state.showCampaignEditSection && (
              <div className="top-section-large">
                <div className="row">
                  <div className="column column-40">
                    <h2>{this.props.focusedCampaign.name}</h2>
                    <p>{this.props.focusedCampaign.description}</p>
                  </div>
                  <div className="column column-20">
                    <div className="row">
                      <div className="column">
                        <div
                          className="button secondary-milligram"
                          onClick={this.handleEditFocusedCampaign}
                        >
                          Edit
                        </div>
                      </div>
                      <div className="column">
                        <div className="button danger" onClick={this.handleRemoveFocusedCampaign}>
                          Deactivate Campaign
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="button-table-top-wrapper">
              <a className="button" onClick={() => this.onOpenEditModal({}, true)}>
                + Add Office
              </a>
            </div>
            <DataTable
              data={this._filterKeysForOfficeDataTable() || []}
              title="Offices"
              actions={[
                {
                  title: 'edit',
                  icon: 'fa-edit',
                  action: (modelInstance) => this.onOpenEditModal(modelInstance),
                },
                {
                  title: 'Remove',
                  icon: 'fa-minus-square',
                  action: this.onOpenDeleteModal,
                },
              ]}
            />
          </div>
        )}{' '}
        {/*END OFFICES SECTION*/}
        {/*  START USERS ACTIVE SECTION  */}
        {this.state.section === 'users' && !this.state.deactivatedUserView && (
          <div>
            <div className="button-table-top-wrapper">
              <button className="button" onClick={() => this.onOpenEditModal({}, true)}>
                + Add User
              </button>
              <button className="button" onClick={this.getDeactivatedUserView}>
                <i className={'fas fa-redo button-icon'} /> Reactivate User
              </button>
            </div>
            <DataTable
              data={this._filterKeysForUserDataTable() || []}
              title="Users"
              actions={[
                {
                  title: 'edit',
                  icon: 'fa-edit',
                  action: (modelInstance) => this.onOpenEditModal(modelInstance),
                },
                {
                  title: 'Deactivate',
                  icon: 'fa-minus-square',
                  action: this.onOpenDeleteModal,
                },
                {
                  title: 'Permissions',
                  icon: 'fa-cog',
                  action: (modelInstance) => this.onOpenPermissionsModal(modelInstance),
                },
              ]}
            />
          </div>
        )}{' '}
        {/*END USERS SECTION*/}
        {/*  START DEACTIVATED USERS SECTION  */}
        {this.state.section === 'users' && this.state.deactivatedUserView && (
          <div>
            <div className="button-table-top-wrapper">
              <button className="button" onClick={() => this.onOpenEditModal({}, true)}>
                + Add User
              </button>
              <button
                className="button"
                onClick={() => this.setState({ deactivatedUserView: false })}
              >
                {' '}
                Return to Active Users
              </button>
            </div>
            <DataTable
              data={this._filterKeysForUserDataTable(true) || []}
              title=" DEACTIVATED Users"
              actions={[
                {
                  title: 'reactivate',
                  icon: 'fa-redo',
                  action: (modelInstance) => this.onOpenReactivateModal(modelInstance),
                },
              ]}
            />
          </div>
        )}{' '}
        {/*END DEACTIVATED USERS SECTION*/}
        {/*  START CAMPAIGNS SECTION  */}
        {this.state.section === 'campaigns' && (
          <div>
            <div className="button-table-top-wrapper">
              <a className="button" onClick={() => this.onOpenEditModal({}, true)}>
                + Add Campaign
              </a>
            </div>
            <DataTable
              data={this._filterKeysForCampaignDataTable() || []}
              title="Campaigns"
              actions={[
                {
                  title: 'edit',
                  icon: 'fa-edit',
                  action: (modelInstance) => this.onOpenEditModal(modelInstance),
                },
                {
                  title: 'Remove',
                  icon: 'fa-minus-square',
                  action: this.onOpenDeleteModal,
                },
              ]}
            />
          </div>
        )}{' '}
        {/*END CAMPAIGNS SECTION*/}
        {/*  START WEBHOOKS SECTION  */}
        {this.state.section === 'webhooks' && (
          <div>
            <div className="button-table-top-wrapper">
              <h5>
                Caution! If you don't know what you are doing here, please leave it to a technical
                administrator. Once created, webhooks can only deleted by a database admin. All
                header files must be entered in as valid JSON.
              </h5>
            </div>

            <div className="button-table-top-wrapper">
              <a className="button" onClick={() => this.onOpenEditModal({}, true)}>
                + Add Webhook
              </a>
            </div>
            <DataTable
              data={this._filterKeysForWebhookDataTable() || []}
              title="Webhooks"
              actions={[
                {
                  title: 'edit',
                  icon: 'fa-edit',
                  action: (modelInstance) => this.onOpenEditModal(modelInstance),
                },
                // {
                //     title: 'Remove',
                //     icon: 'fa-minus-square',
                //     action: this.onOpenDeleteModal,
                // }
              ]}
            />
          </div>
        )}{' '}
        {/*END WEBHOOKS SECTION*/}
        <FeedbackTile
          text={
            <div>
              <i className=" fas fa-asterisk fa-spin" style={{ marginRight: '15px' }} />
              Loading...
            </div>
          }
          visible={this._isLoading()}
        />
        {/*use feedback tile icon, text, state*/}
        <FeedbackTile
          text={
            <div>
              <i className=" fas fa-check-circle" style={{ marginRight: '15px' }} />
              Success
            </div>
          }
          visible={this.state.showSuccess}
          classNames="success"
        />
        <FeedbackTile
          text={<div>{this.state.geoErrorMessage}</div>}
          visible={this.state.geocodeError}
        />
        {/*use feedback tile icon, text, state*/}
        <FeedbackTile
          text={
            <div>
              <i className="fas fa-exclamation-triangle" style={{ marginRight: '15px' }} />
              {this.state.errMsg}
            </div>
          }
          visible={this._isError()}
          classNames="danger"
        />
        <BaseModal open={this.state.editModalOpen} onClose={this.onCloseEditModal} center>
          <BaseForm
            inputs={this.formInputs}
            onCancel={this.onCloseEditModal}
            onSubmit={this.handleUpdateCreateSubmission}
          />
          {!!this.state.editModalErrorMsg && (
            <div className={'danger-text flx center'}>{this.state.editModalErrorMsg}</div>
          )}
        </BaseModal>
        {/*Delete Modal*/}
        <BaseModal open={this.state.deleteModalOpen} onClose={this.onCloseDeleteModal} center>
          <div className="modal-internal-wrapper">
            <p>{this._generateDeleteModalText()}</p>
            <div className="button-wrapper">
              <div className="button" onClick={this.handleRemoveSubmission}>
                Remove
              </div>
              <div className="button button-outline" onClick={this.onCloseDeleteModal}>
                Cancel
              </div>
            </div>
          </div>
        </BaseModal>
        {/* REACTIVATION MODAL */}
        <BaseModal
          open={this.state.reactivateModalOpen}
          onClose={this.onCloseReactivateModal}
          center
        >
          <div className="modal-internal-wrapper">
            <p>Reactivate {this.state.editingInstance.username}?</p>
            <div className="button-wrapper">
              <div className="button" onClick={this.handleReactivateSubmission}>
                Reactivate
              </div>
              <div className="button button-outline" onClick={this.onCloseReactivateModal}>
                Cancel
              </div>
            </div>
          </div>
        </BaseModal>
        {/*UserPermissionsModal*/}
        <BaseModal
          open={this.state.permissionsModalOpen}
          onClose={this.onClosePermissionsModal}
          center
        >
          <div className="modal-internal-wrapper">
            <i
              className="fa fa-times"
              onClick={this.onClosePermissionsModal}
              style={{ float: 'right', cursor: 'pointer' }}
            />
            <p className="primary-text">
              Edit Permissions Groups for <b>{this.permissionsLabel}</b>
            </p>
            {this.adminInputs.length ? (
              <div className="card">
                <h5 className="primary-text">Admin Groups</h5>
                {this.adminInputs}
              </div>
            ) : null}
            <div className="card">
              <h5 className="primary-text">
                Campaign Groups
                <i
                  style={{ float: 'right', padding: '.2em 2em', cursor: 'pointer' }}
                  title="filter"
                  onClick={this.toggleFilter.bind(this)}
                  className="fa fa-filter"
                />
              </h5>
              {this.state.showFilter ? (
                <Input
                  style={{ padding: '0em .5em', margin: '0 .2rem', witdh: '80%' }}
                  title="Filter"
                  type={'text'}
                  onChange={(val) =>
                    this.setState({ filterText: val.toString().toLocaleLowerCase() })
                  }
                  placeholder={'Filter...'}
                  value={this.state.filterText}
                />
              ) : null}
              {filterText(this.permissionsInputs, this.state.filterText)}
            </div>
            <div className="button-wrapper">
              <div className="button button-outline" onClick={this.onClosePermissionsModal}>
                Close
              </div>
            </div>
          </div>
        </BaseModal>
        <BaseModal open={this.state.removeMFAModalOpen} onClose={this.onCloseMFAModal} center>
          <div className="modal-internal-wrapper">
            <p className="primary-text">
              Disable multi-factor auth for {this.state.editingInstance.first_name}{' '}
              {this.state.editingInstance.last_name}?
            </p>
            <div className="button-wrapper">
              <div className="button success" onClick={this.removeMFAFromUser}>
                OK
              </div>
              <div className="button button-outline" onClick={this.onCloseMFAModal}>
                Close
              </div>
            </div>
          </div>
        </BaseModal>
      </NavBaseTemplate>
    );
  }
}

const mapStateToProps = (state) => ({
  campaigns: state.campaigns.data,
  campaigns_error: state.campaigns.error,
  campaigns_loading: state.campaigns.loading,
  focusedCampaign: state.session.focusedCampaign,
  offices: state.offices.data,
  offices_error: state.offices.error,
  offices_loading: state.offices.loading,
  users: state.users.data,
  deactivated_users: state.users.inactiveData,
  users_error: state.users.error,
  users_loading: state.users.loading,
  permissions_loading: state.permissions.loading,
  permissions_error: state.permissions.usergroups_error,
  permissions_groups: state.permissions.groups,
  is_admin: state.permissions.is_admin,
  webhooks: state.alertConfigs.webhooks,
});

//tHIS NEEDS tO MOVE tO tHE tEMPLAtE SCREEN!
const mapDispatchToProps = (dispatch) => ({
  makeInactiveUserActive: (instance) => dispatch(makeInactiveUserActive(instance)),
  updateUser: (data) => dispatch(updateUser(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminScreen);
